module.exports = __webpack_public_path__ + "static/media/photoDetails-campanhaTriibo.ded97762.png";